<mbs-modal
  [isCustomModal]="true"
  [title]="customTitle()"
  #modal>
  <div modal-body>
    <ng-container *ngIf="data()?.resultList?.length; else loader">
      <h5 *ngIf="data().isGroupAction">{{ subTitle() }}</h5>
      <mbs-table-grid
        [multipleSelect]="false"
        classesTable="-accordion"
        rowClasses="background-light"
        childHeaderClasses="background-white"
        bindParentKey="hid"
        bindChildren="childs"
        [collapsibleMode]="true"
        [keepState]="true"
        [viewMode]="sharedPersistentStateEnum.table"
        [disableViewSwitch]="true"
        [stripedTable]="false"
        [showNav]="false"
        [showHeaders]="false"
        [headers]="headers"
        [minHeight]="'200px'"
        [height]="'calc(100vh - 8rem - 139px)'"
        [showChildrenHeaders]="false"
        [subtitleHeaders]="subHeaders"
        [data]="data().resultList">
        <ng-template
          mbsTableCell
          let-error>
          <div class="row align-items-center">
            <div class="col-auto text-center">
              <span class="mbs-table-grid_ico text-primary">
                <i class="fa fa-desktop text-primary"></i>
              </span>
            </div>
            <div class="col">
              <div class="mbs-table-grid_accordion-title">
                {{ error.name || error.displayName }}
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template
          mbsTableCell
          let-error>
          <div class="row justify-content-end">
            <div
              class="col-auto lh-1"
              *ngFor="let child of error.childs">
              @if (child.inProgress) {
                <div class="d-flex align-items-center">
                  <mbs-button
                    [loading]="true"
                    [isCtrl]="true">
                  </mbs-button>
                  <span class="pl-3 pr-1">{{ 'shared:computers.groupOperation.inProgress' | i18next }}</span>
                </div>
              } @else {
                <mbs-status
                  [icon]="child.ok ? 'ico ico-success' : 'ico ico-exclamation-circle'"
                  [type]="child.ok ? type.success : type.danger">
                  {{
                    child.ok ? ('shared:computers.groupOperation.success' | i18next) : ('shared:computers.groupOperation.failed' | i18next)
                  }}
                </mbs-status>
              }
            </div>
          </div>
        </ng-template>

        <ng-template
          mbsTableCell
          group="child"
          let-child>
          <div>
            <div class="form-row mb-1">
              @if (!child.inProgress) {
                <div class="col-auto lh-1 d-flex justify-content-center">
                  <span class="mbs-status">
                    <span class="mbs-status_ico -sm fa fa-circle text-{{ child.ok ? 'success' : 'danger' }} mr-0"></span>
                  </span>
                </div>
              }
              <div class="col lh-1 d-flex align-items-center">
                @let message = extractMessage(child);
                @if (!!message) {
                  <span class="pr-1">{{ message }}</span>
                }
                @if (child.inProgress) {
                  <span class="threedots"></span>
                }
              </div>
            </div>
          </div>
        </ng-template>
      </mbs-table-grid>
    </ng-container>

    <ng-template #loader>
      <div style="height: calc(100vh - 8rem - 139px)"><mbs-loader></mbs-loader></div>
    </ng-template>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="modal.close()">
      {{ 'shared:buttons.close' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
